import { render } from "./question-panel.vue?vue&type=template&id=64f7ee2c&scoped=true&ts=true"
import script from "./question-panel.vue?vue&type=script&lang=ts"
export * from "./question-panel.vue?vue&type=script&lang=ts"

import "./question-panel.vue?vue&type=style&index=0&id=64f7ee2c&lang=scss&scoped=true"
import "./question-panel.vue?vue&type=style&index=1&id=64f7ee2c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f7ee2c"]])

export default __exports__